import { mainService } from '../../services';
import type { UnwrapData } from '../../types';

import type { IUserProfileResponse } from './types';

export const profileService = mainService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить данные профиля пользователя
     */
    getUserProfileData: builder.query<UnwrapData<IUserProfileResponse>, void>({
      query: () => ({
        method: 'GET',
        url: '/user/profile',
      }),
      transformResponse: (response: IUserProfileResponse): UnwrapData<IUserProfileResponse> => response.data,
    }),
  }),
});

export const { useGetUserProfileDataQuery } = profileService;
